import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
  Switch
} from '@mui/material';

const ApprovalModal = ({
  open,
  handleClose,
  initialSettings,
  onApprove
}) => {
  const [localSettings, setLocalSettings] = useState({
    qst_calculation: false,
    gst_calculation: false,
    hst_calculation: false,
    invoice_gen: false,
    paid: false,
    discount: 0,
    remarks: ""
  });

  useEffect(() => {
    if (open) {
      setLocalSettings(initialSettings);
    }
  }, [open, initialSettings]);

  const handleModalClose = () => {
    handleClose();
    setLocalSettings({
      qst_calculation: false,
      gst_calculation: false,
      hst_calculation: false,
      invoice_gen: false,
      paid: false,
      discount: 0,
      remarks: ""
    });
  };

  const handleApprove = () => {
    onApprove(localSettings);
    handleModalClose();
  };

  return (
    <Dialog open={open} onClose={handleModalClose} maxWidth="sm" fullWidth>
      <DialogTitle>Order Approval Settings</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Tax Settings</Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Switch
                checked={localSettings.qst_calculation}
                onChange={(e) => setLocalSettings(prev => ({
                  ...prev,
                  qst_calculation: e.target.checked
                }))}
              />
              <Typography>QST Calculation</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Switch
                checked={localSettings.gst_calculation}
                onChange={(e) => setLocalSettings(prev => ({
                  ...prev,
                  gst_calculation: e.target.checked
                }))}
              />
              <Typography>GST Calculation</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Switch
                checked={localSettings.hst_calculation}
                onChange={(e) => setLocalSettings(prev => ({
                  ...prev,
                  hst_calculation: e.target.checked
                }))}
              />
              <Typography>HST Calculation</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Switch
                checked={localSettings.invoice_gen}
                onChange={(e) => setLocalSettings(prev => ({
                  ...prev,
                  invoice_gen: e.target.checked
                }))}
              />
              <Typography>Generate Invoice</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Switch
                checked={localSettings.paid}
                onChange={(e) => setLocalSettings(prev => ({
                  ...prev,
                  paid: e.target.checked
                }))}
              />
              <Typography>Paid</Typography>
            </Box>
          </Box>

          <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mt: 2 }}>Discount Settings</Typography>
          <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
            <TextField
              label="Discount Amount"
              // type="number"
              value={localSettings.discount}
              onChange={(e) => {
                const value = e.target.value;
                if (value === '') {
                  setLocalSettings(prev => ({
                    ...prev,
                    discount: ''
                  }));
                } else {
                  setLocalSettings(prev => ({
                    ...prev,
                    discount: Math.max(0, Math.min(1000000, Number(value)))
                  }));
                }
              }}
              InputProps={{
                inputProps: {
                  min: 0,
                  max: 1000000
                }
              }}
              sx={{ width: 200 }}
            />
          </Box>

          <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mt: 2 }}>Remarks</Typography>
          <TextField
            label="Remarks"
            value={localSettings.remarks}
            onChange={(e) => setLocalSettings(prev => ({
              ...prev,
              remarks: e.target.value.slice(0, 200)
            }))}
            multiline
            rows={3}
            fullWidth
            placeholder="Enter any approval notes or comments..."
            InputProps={{
              inputProps: {
                maxLength: 200
              }
            }}
            FormHelperTextProps={{
              sx: { textAlign: 'right' }
            }}
            helperText={`${(localSettings.remarks ?? "").length} / 200`}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleModalClose}>Cancel</Button>
        <Button
          onClick={handleApprove}
          variant="contained"
          color="primary"
        >
          Approve Order
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ApprovalModal;
